import React from 'react';
import { featuresData } from '../data/mock';
import { UtensilsCrossed, Shield, Heart, Crown } from 'lucide-react';

const iconMap = {
  UtensilsCrossed,
  Shield,
  Heart,
  Crown
};

const FeaturesGrid = () => {
  return (
    <section className="py-20 md:py-28 bg-[#1A2B3C]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-lato text-[#D4AF37] uppercase tracking-[0.3em] text-sm mb-4 block">At a Glance</span>
          <h2 className="font-playfair text-3xl md:text-4xl text-white">The FIJA Difference</h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {featuresData.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group relative p-8 rounded-lg bg-[#1A2B3C] border border-[#D4AF37]/20 hover:border-[#D4AF37]/60 transition-all duration-500"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon Container */}
                <div className="w-16 h-16 mb-6 rounded-full border-2 border-[#D4AF37]/40 flex items-center justify-center group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-all duration-500">
                  <IconComponent className="w-7 h-7 text-[#D4AF37]" />
                </div>

                <h3 className="font-playfair text-xl text-white mb-3 group-hover:text-[#D4AF37] transition-colors duration-300">
                  {feature.title}
                </h3>

                <p className="font-lato text-white/60 text-sm leading-relaxed">
                  {feature.description}
                </p>

                {/* Hover accent */}
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
